import { registerAction } from '../../Action'

const updateNestedState = (state, updates) => ({
  ...state,
  entityDataByView: {
    ...(state.entityDataByView && state.entityDataByView),
    assignmentsView: {
      ...(state.entityDataByView && state.entityDataByView.assignmentsView),
      ...updates,
    },
  },
})

const RESET_ASSIGNMENTS_VIEW_PAGINATION = 'RESET ASSIGNMENTS VIEW PAGINATION'

const reducer = (state = {}, action) =>
  updateNestedState(state, {
    [action.payload.entityType]: [],
  })

const resetAssignmentsViewPagination = registerAction(
  RESET_ASSIGNMENTS_VIEW_PAGINATION,
  { reducer }
)

export default resetAssignmentsViewPagination
